/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { makeApi, URLS } from 'Utils/apiUtil';
import { observer } from 'mobx-react';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as DownArrowIcon } from 'Assets/svg/down-arrow-icon.svg';

import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';
import { ReactComponent as InfoIcon } from '../../../assets/svg/info-icon.svg';
import excludeSuppressionListDomainSampleFile from '../../../assets/csv/sampleExcludeSuppressionListDomain.csv';
import excludeSuppressionListEmailSampleFile from '../../../assets/csv/sampleExcludeSuppressionListEmail.csv';
import Button from './Button';
import { toasterState } from './toaster';

class SuppressionListUploadState {
  @observable showCreateList = false;

  @observable getListLoading = false;

  @observable suppressionListEntries = [];

  @observable suppressionListLoaded = false;

  @observable callBack = () => {};

  @action
  setGetListLoading = (val = false) => {
    this.getListLoading = val;
  };

  @action
  setSuppressionListEntries = (val = []) => {
    this.suppressionListEntries = val;
  };

  @action
  setShowCreateList = val => {
    this.showCreateList = val;
    if (val)
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
    else
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
  };

  verifyCsvEntries = (
    entries,
    type,
    isInclusion = false,
    callback = () => {},
  ) => {
    const config = {
      url: URLS.suppressionList.getValidEntries,
      method: 'POST',
      data: { entries, type },
    };
    console.log('config ', config);
    Utils.mixpanelTrack(
      CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_ADD_LIST_VERIFY,
      { listType: type, isInclusion },
    );
    makeApi(config)
      .then(response => {
        if (response && response.status === 200 && response.data !== undefined)
          callback(response.data);
        else callback(null);
      })
      .catch(error => {
        console.log('getValidDomains error ', error);
      });
  };

  saveNewList = (
    entries,
    type,
    listName,
    isInclusion = false,
    callback = () => {},
  ) => {
    const config = {
      url: URLS.suppressionList.saveList,
      method: 'POST',
      data: { entries, type, listName, isInclusion },
    };
    Utils.mixpanelTrack(CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_SAVE_LIST, {
      listType: type,
      listName,
      isInclusion,
    });
    makeApi(config)
      .then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data !== undefined
        ) {
          callback(response.data);
          Utils.mixpanelTrack(
            CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_LIST_CREATED_SUCCESS,
            {
              listType: type,
              listName,
              isInclusion,
            },
          );
        } else {
          callback(null);
        }
      })
      .catch(error => {
        console.log('getValidDomains error ', error);
      });
  };

  enableDisableList = (listId, actionType = 'enable', callback = () => {}) => {
    const config = {
      url: URLS.suppressionList.enableDisableList,
      method: 'POST',
      data: { listId, action: actionType },
    };
    Utils.mixpanelTrack(CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_TOGGLE, {
      listId,
      actionType,
    });
    makeApi(config)
      .then(response => {
        console.log('enableDisableList res', response);
        if (response && response.status === 200 && response.data !== undefined)
          callback(response.data);
        else callback(null);
      })
      .catch(error => {
        console.log('enableDisableList error ', error);
        callback(null);
      });
  };

  deleteList = (listId, callback = () => {}) => {
    const config = {
      url: URLS.suppressionList.deleteList,
      method: 'DELETE',
      data: { listId },
    };
    Utils.mixpanelTrack(CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_DELETE, {
      listId,
    });
    makeApi(config)
      .then(response => {
        console.log('deleteList res', response);
        if (response && response.status === 200 && response.data !== undefined)
          callback(response.data);
        else callback(null);
      })
      .catch(error => {
        console.log('deleteList error ', error);
        callback(null);
      });
  };

  downloadList = (listId, callback = () => {}) => {
    const config = {
      url: URLS.suppressionList.downloadList,
      method: 'POST',
      data: { listId },
    };
    Utils.mixpanelTrack(CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_DOWNLOAD, {
      listId,
    });
    makeApi(config)
      .then(response => {
        console.log('downloadList res', response);
        if (response && response.status === 200 && response.data !== undefined)
          callback(response.data);
        else callback(null);
      })
      .catch(error => {
        console.log('downloadList error ', error);
        callback(null);
      });
  };

  @action
  getSuppressionList = (type = 'exclusion') => {
    const config = {
      url: URLS.suppressionList.getList + type,
      method: 'GET',
    };
    this.getListLoading = true;
    makeApi(config)
      .then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data !== undefined &&
          response.data.list !== undefined &&
          response.data.list !== null
        )
          this.setSuppressionListEntries(response.data.list);

        
        this.suppressionListLoaded = true;
        this.getListLoading = false;
      })
      .catch(error => {
        this.getListLoading = false;
        console.log('getValidDomains error ', error);
      });
  };
}
const suppressionListUploadState = new SuppressionListUploadState();

const SuppressionListUploadPopup = observer(props => {
  const [selectedListType, setSelectedListType] = React.useState('');
  const ERROR_FIELD = {
    CHOOSE_LIST_TYPE: 'CHOOSE_LIST_TYPE',
    ENTER_LIST_NAME: 'ENTER_LIST_NAME',
    UPLOAD_NEW_LIST: 'UPLOAD_NEW_LIST',
  };
  const typesOfList = {
    DOMAIN: 'Domain',
    EMAIL: 'Email',
  };
  const [
    showListTypeBoxSuggestion,
    setShowListTypeBoxSuggestion,
  ] = React.useState(false);
  const [selectedListName, setSelectedListName] = React.useState('');

  const [errorToolMsg, showErrorToolMsg] = React.useState('');
  const [inputValidation, setInputValidation] = React.useState({});
  const [listEntries, setListEntries] = React.useState([]);
  const [verifiedListEntries, setVerifiedListEntries] = React.useState([]);
  const [uploadedFileName, setUploadedFileName] = React.useState('');
  const [isVerified, setIsVerified] = React.useState('');
  const [listVerifyMsg, setListVerifyMsg] = React.useState('');

  const [fileUpload, setFileUpload] = React.useState(true);

  const [isLoading, setIsLoading] = React.useState(false);

  const changeInputVal = value => {
    showErrorToolMsg('');
    if (inputValidation[ERROR_FIELD.ENTER_LIST_NAME] !== null) {
      const newValObj = Utils.copyObjectWithoutReference(inputValidation);
      delete newValObj[ERROR_FIELD.ENTER_LIST_NAME];
      setInputValidation(newValObj);
    }
    setSelectedListName(value);
  };

  const closeListPopup = () => {
    suppressionListUploadState.setGetListLoading(false);
    suppressionListUploadState.setShowCreateList(false);
  };

  const onInputLimitClick = e => {
    setShowListTypeBoxSuggestion(!showListTypeBoxSuggestion);
  };

  const closeSuggestion = () => {
    if (showListTypeBoxSuggestion) setShowListTypeBoxSuggestion(false);
  };

  const onContactLimitChnage = (e, val) => {
    showErrorToolMsg('');
    if (inputValidation[ERROR_FIELD.CHOOSE_LIST_TYPE] !== null) {
      const newValObj = Utils.copyObjectWithoutReference(inputValidation);
      delete newValObj[ERROR_FIELD.CHOOSE_LIST_TYPE];
      setInputValidation(newValObj);
    }
    setIsVerified('');
    setSelectedListType(val);
    closeSuggestion();
  };

  const submitAction = e => {
    if (e.charCode === 13) getContacts();
  };

  const verifyCsvEntries = entries => {
    setIsVerified('verifying');
    setListVerifyMsg('');
    const verifyCallback = response => {
      console.log('response ', response);
      const {
        errorCode = null,
        validEntries = null,
        remainingEntriesCount = null,
      } = response;
      if (errorCode === null && validEntries !== null && validEntries.length) {
        setIsVerified('true');
        setVerifiedListEntries(validEntries);
        const msg = `Found ${validEntries.length} valid ${
          selectedListType === 'DOMAIN'
            ? `${validEntries.length > 1 ? 'domains' : 'domain'}`
            : `${validEntries.length > 1 ? 'emails' : 'email'}`
        } to suppress in search results`;
        setListVerifyMsg(msg);

        console.log('validEntries ', validEntries);
      } else if (
        errorCode === 203 ||
        (validEntries !== null && validEntries.length === 0)
      ) {
        setIsVerified('error');
        setListVerifyMsg('Uploaded list has no valid rows.');
        Utils.mixpanelTrack(
          CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
          {
            errorLocation: 'VERIFICATION',
            errorType: 'EMPTY_ROWS',
          },
        );
        console.log('empty list');
      } else if (errorCode === 202) {
        setIsVerified('error');
        setListVerifyMsg('Maximum number of rows allowed is 25K / List.');
        Utils.mixpanelTrack(
          CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
          {
            errorLocation: 'VERIFICATION',
            errorType: 'LIMIT_EXCEED_PER_LIST',
          },
        );
        console.log('empty list');
      } else if (errorCode === 201) {
        if (remainingEntriesCount !== null) {
          setIsVerified('error_custom');
          setListVerifyMsg(remainingEntriesCount);
        } else {
          setIsVerified('error');
          let msg = '';
          if (selectedListType === 'EMAIL')
            msg =
              'Oops! You have reached the limit of 500K emails in your suppression list.';
          else
            msg =
              'Oops! You have reached the limit of 100K domains in your suppression list.';
          setListVerifyMsg(msg);
        }
        Utils.mixpanelTrack(
          CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
          {
            errorLocation: 'VERIFICATION',
            errorType: 'LIMIT_EXCEED_TOTAL_VALUE',
          },
        );
      } else {
        setIsVerified('error');
        const msg =
          'Unable to process your request now, please try again later';
        setListVerifyMsg(msg);
        Utils.mixpanelTrack(
          CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
          {
            errorLocation: 'VERIFICATION',
            errorType: 'UNKNOWN_ERROR',
          },
        );
      }
    };
    suppressionListUploadState.verifyCsvEntries(
      entries,
      selectedListType,
      false,
      verifyCallback,
    );
  };

  const onFileChange = async e => {
    setIsVerified('');
    const callBack = data => {
      if (!data) {
        console.log('empty file', data);
        showErrorToolMsg('Uploaded list has no valid rows.');
      } else if (data !== '' && data === 'error') {
        console.log('max length error', data);
        showErrorToolMsg(
          `Maximum number of rows allowed is ${
            selectedListType === 'EMAIL'
              ? Utils.getSuppressionListEmailLimit() / 1000
              : '25'
          }K / List.`,
        );
      } else {
        console.log('data ', data);
        if (inputValidation[ERROR_FIELD.UPLOAD_NEW_LIST] !== null) {
          const newValObj = Utils.copyObjectWithoutReference(inputValidation);
          delete newValObj[ERROR_FIELD.UPLOAD_NEW_LIST];
          setInputValidation(newValObj);
        }
        const { fname, entries } = data;
        setListEntries(entries);
        setUploadedFileName(fname);
        verifyCsvEntries(entries);
      }
      setTimeout(function() {
        setFileUpload(false);
      }, 0);
      setTimeout(function() {
        setFileUpload(true);
      }, 50);
    };
    if (selectedListType === 'EMAIL')
      Utils.uploadCsv(e, callBack, true, Utils.getSuppressionListEmailLimit());
    else Utils.uploadCsv(e, callBack, true, 25000);
  };

  const triggerUpload = e => {
    setInputValidation({});
    const validationObj = {};
    if (selectedListType === '')
      validationObj[ERROR_FIELD.CHOOSE_LIST_TYPE] = 1;
    if (selectedListName === '') validationObj[ERROR_FIELD.ENTER_LIST_NAME] = 1;

    if (Object.keys(validationObj).length === 0) {
      showErrorToolMsg('');
      // eslint-disable-next-line no-undef
      document.getElementById('uploadSuppressionListCsv').click();
    } else {
      setInputValidation(validationObj);
    }
  };

  const saveUserList = () => {
    showErrorToolMsg('');
    setInputValidation({});
    const validationObj = {};
    if (selectedListType === '')
      validationObj[ERROR_FIELD.CHOOSE_LIST_TYPE] = 1;
    if (selectedListName === '') validationObj[ERROR_FIELD.ENTER_LIST_NAME] = 1;
    if (verifiedListEntries.length === 0)
      validationObj[ERROR_FIELD.UPLOAD_NEW_LIST] = 1;

    if (
      Object.keys(validationObj).length === 0 &&
      verifiedListEntries.length > 0 &&
      isVerified === 'true'
    ) {
      setIsLoading(true);
      const saveCallback = response => {
        console.log('response', response);

        const { listDetail = null, errorCode = null } = response || {};

        console.log('listDetail ', listDetail);
        console.log('errorCode ', errorCode);

        if (errorCode === null && response !== null) {
          if (listDetail !== null) {
            const newList = Utils.copyObjectWithoutReference(
              suppressionListUploadState.suppressionListEntries,
            );
            newList.push(listDetail);
            suppressionListUploadState.setSuppressionListEntries(newList);
          }

          toasterState.setToastMsg(
            'Your suppression list is being processed. It may take a while. <br /> You will receive an email once it is complete',
            'success',
          );
          setIsLoading(false);
          suppressionListUploadState.setShowCreateList(false);
        } else if (errorCode === 203) {
          setIsVerified('error');
          setListVerifyMsg('Uploaded list has no valid rows.');
          Utils.mixpanelTrack(
            CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
            {
              errorLocation: 'SAVE',
              errorType: 'EMPTY_ROWS',
            },
          );
          console.log('empty list');
        } else if (errorCode === 202) {
          setIsVerified('error');
          setListVerifyMsg('Maximum number of rows allowed is 25K / List.');
          console.log('empty list');
          Utils.mixpanelTrack(
            CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
            {
              errorLocation: 'SAVE',
              errorType: 'LIMIT_EXCEED_PER_LIST',
            },
          );
        } else if (errorCode === 201) {
          if (remainingEntriesCount !== null) {
            setIsVerified('error_custom');
            setListVerifyMsg(remainingEntriesCount);
          } else {
            setIsVerified('error');
            let msg = '';
            if (selectedListType === 'EMAIL')
              msg =
                'Oops! You have reached the limit of 500K emails in your suppression list.';
            else
              msg =
                'Oops! You have reached the limit of 100K domains in your suppression list.';
            setListVerifyMsg(msg);
          }
          Utils.mixpanelTrack(
            CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
            {
              errorLocation: 'SAVE',
              errorType: 'LIMIT_EXCEED_TOTAL_VALUE',
            },
          );
        } else {
          setIsVerified('error');
          const msg =
            'Unable to process your request now, please try again later';
          setListVerifyMsg(msg);
          Utils.mixpanelTrack(
            CONSTANTS.MX_SUPPRESSION_LIST_EVENTS.LB_SL_UPLOAD_FAILED,
            {
              errorLocation: 'SAVE',
              errorType: 'UNKNOWN_ERROR',
            },
          );
        }
      };
      suppressionListUploadState.saveNewList(
        verifiedListEntries,
        selectedListType,
        selectedListName,
        false,
        saveCallback,
      );
    } else {
      setInputValidation(validationObj);
    }
  };

  React.useEffect(() => {
    if (!suppressionListUploadState.showCreateList) {
      setSelectedListName('');
      setSelectedListType('');
      setShowListTypeBoxSuggestion(false);
      showErrorToolMsg('');
      setInputValidation({});
      showErrorToolMsg('');
      setListEntries([]);
      setUploadedFileName('');
      setIsVerified('');
      setListVerifyMsg('');
      setVerifiedListEntries([]);
      setIsLoading(false);
    }
  }, [suppressionListUploadState.showCreateList]);

  return suppressionListUploadState.showCreateList ? (
    <>
      <div className="suppression-list-create-popup common-popup">
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => closeListPopup()}
          >
            <CloseIcon />
          </div>
          <div className="title">
            Add New List
            <div className="short-info">
              Upload specific domains or email IDs to be excluded
              <br /> from search results. Limited to 25k rows / list. <br /> (
              <a
                className="sample-csv"
                href={excludeSuppressionListEmailSampleFile}
                download=""
              >
                Email Sample
              </a>
              ) (
              <a
                className="sample-csv"
                href={excludeSuppressionListDomainSampleFile}
                download=""
              >
                Domain Sample
              </a>
              )
            </div>
          </div>
          <div className="popup-content-wrap">
            <div className="dropdown-section location-preference">
              <div
                className={`dropdown-box ${
                  inputValidation[ERROR_FIELD.CHOOSE_LIST_TYPE] !== undefined
                    ? 'error-border'
                    : ''
                }`}
                onClick={onInputLimitClick}
              >
                <span>
                  {selectedListType !== ''
                    ? typesOfList[selectedListType]
                    : 'Choose List Type'}
                </span>
                <DownArrowIcon
                  className={`dropdown-icon downarrow-icon plus-icon ${
                    showListTypeBoxSuggestion ? ' rotate-arrow' : ''
                  }`}
                  width={18}
                  height={18}
                />
              </div>
              <div
                className={`suggestion-list radio-btn-wrap animatedFast animatedDropDown ${
                  showListTypeBoxSuggestion ? '' : 'hide-suggestion'
                }`}
              >
                <div className="radio-wrapper">
                  {Object.keys(typesOfList).map(item => {
                    return (
                      <div
                        key={item}
                        className={`radio-item${
                          selectedListType === item ? ' selected' : ''
                        }`}
                        onClick={e => onContactLimitChnage(e, item)}
                      >
                        <div className="radio-text-new">
                          {typesOfList[item]}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="create-list-input-wrap">
              <input
                id="createUpdateListbox"
                className={`input-box ${
                  inputValidation[ERROR_FIELD.ENTER_LIST_NAME] !== undefined
                    ? 'error-border'
                    : ''
                }`}
                type="text"
                placeholder="List name"
                value={selectedListName}
                onChange={e => changeInputVal(e.currentTarget.value)}
                onKeyPress={submitAction}
                autoComplete="off"
              />
            </div>
            <div className="csv-upload-wrapper upload-csv">
              {fileUpload && (
                <input
                  id="uploadSuppressionListCsv"
                  className="custom-file-input"
                  type="file"
                  accept=".csv"
                  onChange={onFileChange}
                />
              )}
              <div
                className={`upload-btn ${
                  inputValidation[ERROR_FIELD.UPLOAD_NEW_LIST] !== undefined
                    ? 'error-border'
                    : ''
                }`}
                onClick={e => triggerUpload(e)}
              >
                Choose a file
              </div>
              {uploadedFileName !== '' && (
                <div className="uploaded-file-name">{uploadedFileName}</div>
              )}
            </div>
            <div className={`${errorToolMsg !== '' ? 'show' : ''} error-text`}>
              {errorToolMsg}
            </div>
            {(isVerified === 'true' ||
              isVerified === 'error' ||
              isVerified === 'error_custom') && (
              <div
                className={`verifyed-info-wrapper ${
                  isVerified === 'error' || isVerified === 'error_custom'
                    ? ' error'
                    : ''
                }`}
              >
                <InfoIcon width={18} height={18} className="title-info-icon" />
                {isVerified === 'error_custom' ? (
                  <div className="verifyed-info">
                    {listVerifyMsg === 0 ? (
                      <span>
                        Sorry, you have hit the limit of
                        <span className="span-ml span-mr">
                          {selectedListType === 'EMAIL'
                            ? '500K emails'
                            : '100K domains'}
                        </span>
                        in your suppression list. You cannot suppress any more
                        <span className="span-ml span-mr">
                          {selectedListType === 'EMAIL' ? 'emails' : 'domains'}
                        </span>
                      </span>
                    ) : (
                      <span>
                        Oops! You are about to hit the limit of
                        <span className="span-ml span-mr">
                          {selectedListType === 'EMAIL'
                            ? '500K emails'
                            : '100K domains'}
                        </span>{' '}
                        in your suppression list. Please reduce the number of
                        <span className="span-ml span-mr">
                          {selectedListType === 'EMAIL' ? 'emails' : 'domains'}
                        </span>
                        in the uploaded file to{' '}
                        {Utils.usNumberFormat(listVerifyMsg)} rows and try
                        again.
                      </span>
                    )}
                  </div>
                ) : (
                  <div
                    className="verifyed-info"
                    dangerouslySetInnerHTML={{
                      __html: listVerifyMsg || '',
                    }}
                  />
                )}
              </div>
            )}
            {isVerified === 'verifying' && (
              <div className="verifying-msg">Verifying ...</div>
            )}
            {showListTypeBoxSuggestion && (
              <div className="suggestion-mask" onClick={closeSuggestion} />
            )}
          </div>
          <div className="popup-action-wrap">
            <Button
              btnText="Save"
              icon={false}
              iconName=""
              type="button"
              className={`popup-action-btn positive-btn${
                isLoading ? ' loading' : ''
              }`}
              loader={isLoading}
              click={() => saveUserList()}
            />
            <div className="popup-action-btn" onClick={() => closeListPopup()}>
              Cancel
            </div>
          </div>
        </div>
      </div>
      <div className="common-popup-mask" onClick={() => closeListPopup()} />
    </>
  ) : (
    ''
  );
});

export { SuppressionListUploadPopup, suppressionListUploadState };
export default SuppressionListUploadPopup;
